import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SearchIcon, DatabaseIcon, SendIcon, CheckCircle2Icon, StarIcon, LinkedinIcon } from 'lucide-react';
export function ProductDemo() {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [{
    id: 0,
    label: 'Search businesses',
    icon: SearchIcon
  }, {
    id: 1,
    label: 'Enrich contacts',
    icon: DatabaseIcon
  }, {
    id: 2,
    label: 'Launch outreach',
    icon: SendIcon
  }];
  const searchResults = [{
    name: 'Austin Taco Co.',
    category: 'Restaurant',
    location: 'Austin, TX',
    phone: '(512) 555-0199',
    rating: 4.8,
    reviews: 342,
    website: 'austintaco.com',
    email: 'info@austintaco.com'
  }, {
    name: 'Hill Country HVAC',
    category: 'HVAC Services',
    location: 'San Antonio, TX',
    phone: '(210) 555-0234',
    rating: 4.6,
    reviews: 189,
    website: 'hillcountryhvac.com',
    email: 'service@hchvac.com'
  }, {
    name: 'Lakewood Dental',
    category: 'Dentist',
    location: 'Dallas, TX',
    phone: '(214) 555-0567',
    rating: 4.9,
    reviews: 521,
    website: 'lakewooddental.com',
    email: 'hello@lakewooddental.com'
  }, {
    name: 'Sunrise Yoga Studio',
    category: 'Fitness',
    location: 'Houston, TX',
    phone: '(713) 555-0891',
    rating: 4.7,
    reviews: 156,
    website: 'sunriseyoga.co',
    email: 'info@sunriseyoga.co'
  }];
  const enrichedContacts = [{
    initials: 'MG',
    name: 'Maria Garcia',
    title: 'Owner @ Austin Taco Co.',
    email: 'maria@austintaco.com',
    phone: '(512) 555-0199',
    revenue: '$1.2M',
    employees: '15',
    tech: 'Toast, DoorDash'
  }, {
    initials: 'JW',
    name: 'James Wilson',
    title: 'Founder @ Hill Country HVAC',
    email: 'james@hchvac.com',
    phone: '(210) 555-0234',
    revenue: '$3.5M',
    employees: '28',
    tech: 'ServiceTitan'
  }, {
    initials: 'SC',
    name: 'Dr. Sarah Chen',
    title: 'Owner @ Lakewood Dental',
    email: 'sarah@lakewooddental.com',
    phone: '(214) 555-0567',
    revenue: '$2.1M',
    employees: '12',
    tech: 'Dentrix'
  }];
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3273">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-16" data-id="element-3274">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-3275">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-3276">
            See Openmart <span className="text-blue-600" data-id="element-3277">in action</span>
          </h2>
          <p className="text-lg text-slate-500" data-id="element-3278">
            Explore how easy it is to build your pipeline.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-3279">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-3 rounded-full text-sm font-bold transition-all ${activeTab === tab.id ? 'bg-slate-900 text-white shadow-md' : 'bg-slate-50 text-slate-600 hover:bg-slate-100'}`} data-id="element-3280">
              <tab.icon className="w-4 h-4" data-id="element-3281" />
              {tab.label}
            </button>)}
        </div>

        {/* Content Area */}
        <div className="bg-slate-50 rounded-3xl border border-slate-200 overflow-hidden h-[480px] relative" data-id="element-3282">
          <AnimatePresence mode="wait" data-id="element-3283">
            {activeTab === 0 && <motion.div key="search" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} className="p-8 h-full flex flex-col" data-id="element-3284">
                <div className="flex gap-4 mb-4 items-center" data-id="element-3285">
                  <div className="flex-1 bg-white rounded-xl border border-slate-200 px-4 py-3 flex items-center gap-3 shadow-sm" data-id="element-3286">
                    <SearchIcon className="w-5 h-5 text-slate-400" data-id="element-3287" />
                    <span className="text-slate-400 font-medium" data-id="element-3288">
                      Restaurants in Austin, TX
                    </span>
                  </div>
                  <button className="bg-blue-600 text-white px-6 py-3 rounded-xl font-bold shadow-sm" data-id="element-3289">
                    Search
                  </button>
                </div>
                <div className="mb-4" data-id="element-3290">
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-bold" data-id="element-3291">
                    2,847 businesses found
                  </span>
                </div>
                <div className="flex-1 bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden relative" data-id="element-3292">
                  <div className="absolute top-0 bottom-0 right-0 w-12 bg-gradient-to-l from-white to-transparent pointer-events-none z-10" data-id="element-3293" />
                  <div className="overflow-x-auto h-full" data-id="element-3294">
                    <div className="min-w-[1000px]" data-id="element-3295">
                      <div className="grid grid-cols-[2fr_1.5fr_1.5fr_1.5fr_1fr_1fr_1.5fr_1.5fr] border-b border-slate-100 bg-slate-50 p-4 text-xs font-bold text-slate-500 uppercase tracking-wider sticky top-0 z-0" data-id="element-3296">
                        <div data-id="element-3297">Business Name</div>
                        <div data-id="element-3298">Category</div>
                        <div data-id="element-3299">Location</div>
                        <div data-id="element-3300">Phone</div>
                        <div data-id="element-3301">Rating</div>
                        <div data-id="element-3302">Reviews</div>
                        <div data-id="element-3303">Website</div>
                        <div data-id="element-3304">Email</div>
                      </div>
                      {searchResults.map((row, i) => <div key={i} className="grid grid-cols-[2fr_1.5fr_1.5fr_1.5fr_1fr_1fr_1.5fr_1.5fr] border-b border-slate-50 p-4 text-sm text-slate-700 items-center hover:bg-slate-50/50 transition-colors" data-id="element-3305">
                          <div className="font-bold text-slate-900 truncate pr-4" data-id="element-3306">
                            {row.name}
                          </div>
                          <div className="truncate pr-4" data-id="element-3307">{row.category}</div>
                          <div className="truncate pr-4" data-id="element-3308">{row.location}</div>
                          <div className="truncate pr-4" data-id="element-3309">{row.phone}</div>
                          <div className="flex items-center gap-1 text-amber-500 font-medium" data-id="element-3310">
                            <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-3311" />
                            {row.rating}
                          </div>
                          <div data-id="element-3312">{row.reviews}</div>
                          <div className="truncate pr-4 text-blue-600" data-id="element-3313">
                            {row.website}
                          </div>
                          <div className="truncate pr-4" data-id="element-3314">{row.email}</div>
                        </div>)}
                    </div>
                  </div>
                </div>
              </motion.div>}

            {activeTab === 1 && <motion.div key="enrich" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} className="p-8 h-full flex flex-col" data-id="element-3315">
                <div className="flex justify-between items-center mb-6" data-id="element-3316">
                  <h3 className="font-bold text-slate-900 text-lg" data-id="element-3317">
                    Contact Enrichment
                  </h3>
                  <button className="bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-sm" data-id="element-3318">
                    Enrich 2,847 contacts
                  </button>
                </div>
                <div className="space-y-3 overflow-y-auto pr-2 custom-scrollbar" data-id="element-3319">
                  {enrichedContacts.map((contact, i) => <div key={i} className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm" data-id="element-3320">
                      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-3" data-id="element-3321">
                        <div className="flex items-center gap-4" data-id="element-3322">
                          <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-blue-600 font-bold shrink-0" data-id="element-3323">
                            {contact.initials}
                          </div>
                          <div data-id="element-3324">
                            <div className="font-bold text-slate-900" data-id="element-3325">
                              {contact.name}
                            </div>
                            <div className="text-xs text-slate-500" data-id="element-3326">
                              {contact.title}
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-wrap gap-2 sm:justify-end" data-id="element-3327">
                          <div className="flex items-center gap-1.5 bg-green-50 text-green-700 px-2.5 py-1 rounded-md text-xs font-bold" data-id="element-3328">
                            <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-3329" />
                            {contact.email}
                          </div>
                          <div className="flex items-center gap-1.5 bg-blue-50 text-blue-700 px-2.5 py-1 rounded-md text-xs font-bold" data-id="element-3330">
                            <LinkedinIcon className="w-3.5 h-3.5" data-id="element-3331" />
                            LinkedIn
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-2 sm:ml-14" data-id="element-3332">
                        <div className="bg-slate-100 text-slate-600 px-2.5 py-1 rounded-md text-xs font-medium" data-id="element-3333">
                          Phone: {contact.phone}
                        </div>
                        <div className="bg-slate-100 text-slate-600 px-2.5 py-1 rounded-md text-xs font-medium" data-id="element-3334">
                          Revenue: {contact.revenue}
                        </div>
                        <div className="bg-slate-100 text-slate-600 px-2.5 py-1 rounded-md text-xs font-medium" data-id="element-3335">
                          Employees: {contact.employees}
                        </div>
                        <div className="bg-slate-100 text-slate-600 px-2.5 py-1 rounded-md text-xs font-medium" data-id="element-3336">
                          Tech: {contact.tech}
                        </div>
                      </div>
                    </div>)}
                </div>
              </motion.div>}

            {activeTab === 2 && <motion.div key="outreach" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} className="p-8 h-full flex flex-col" data-id="element-3337">
                <div className="flex justify-between items-center mb-6" data-id="element-3338">
                  <div className="flex items-center gap-3" data-id="element-3339">
                    <h3 className="font-bold text-slate-900 text-lg" data-id="element-3340">
                      Sequence Builder
                    </h3>
                    <span className="text-sm text-slate-500 font-medium hidden sm:inline-block" data-id="element-3341">
                      245 contacts • 3 steps • Est. 68% open rate
                    </span>
                  </div>
                  <button className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-sm" data-id="element-3342">
                    Launch Campaign
                  </button>
                </div>
                <div className="flex-1 bg-white rounded-xl border border-slate-200 shadow-sm p-6 relative overflow-y-auto" data-id="element-3343">
                  <div className="absolute left-10 top-10 bottom-10 w-0.5 bg-slate-100" data-id="element-3344"></div>
                  <div className="space-y-6 relative z-10" data-id="element-3345">
                    <div className="flex gap-4" data-id="element-3346">
                      <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-xs shadow-md shrink-0" data-id="element-3347">
                        1
                      </div>
                      <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 p-4" data-id="element-3348">
                        <div className="text-xs font-bold text-blue-600 mb-2" data-id="element-3349">
                          Day 1 • Initial Email
                        </div>
                        <div className="font-bold text-slate-900 text-sm mb-1" data-id="element-3350">
                          Subject: Quick question about {'{{company_name}}'}
                        </div>
                        <div className="text-sm text-slate-600" data-id="element-3351">
                          Hi {'{{owner_name}}'}, I noticed {'{{company_name}}'}{' '}
                          in {'{{city}}'} has {'{{rating}}'} stars across{' '}
                          {'{{review_count}}'} reviews...
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-4" data-id="element-3352">
                      <div className="w-8 h-8 rounded-full bg-white border-2 border-slate-200 text-slate-400 flex items-center justify-center font-bold text-xs shrink-0" data-id="element-3353">
                        2
                      </div>
                      <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 p-4" data-id="element-3354">
                        <div className="text-xs font-bold text-slate-500 mb-2" data-id="element-3355">
                          Day 4 • Follow up
                        </div>
                        <div className="font-bold text-slate-900 text-sm mb-1" data-id="element-3356">
                          Subject: Re: Quick question about {'{{company_name}}'}
                        </div>
                        <div className="text-sm text-slate-600" data-id="element-3357">
                          Just following up — I think our solution could help{' '}
                          {'{{company_name}}'} given your {'{{employee_count}}'}{' '}
                          team...
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-4" data-id="element-3358">
                      <div className="w-8 h-8 rounded-full bg-white border-2 border-slate-200 text-slate-400 flex items-center justify-center font-bold text-xs shrink-0" data-id="element-3359">
                        3
                      </div>
                      <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 p-4" data-id="element-3360">
                        <div className="text-xs font-bold text-slate-500 mb-2" data-id="element-3361">
                          Day 7 • Final follow-up
                        </div>
                        <div className="font-bold text-slate-900 text-sm mb-1" data-id="element-3362">
                          Subject: {'{{owner_name}}'}, one last thought
                        </div>
                        <div className="text-sm text-slate-600" data-id="element-3363">
                          Since {'{{company_name}}'} uses {'{{tech_stack}}'}, I
                          wanted to share...
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}